import PolicyPrivacy from "view3/PolicyPrivacy.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

const PolicyPrivacyContainer = connectFunction(mapStateToProps)(PolicyPrivacy);
export default PolicyPrivacyContainer;
